<template>
    <flex-container align-items="center" justify-content="center">
        <flex-container :size="3" :gap="Size.xl">
            <logo-icon />

            <flex-container>
                <text-heading>
                    Wachtwoord instellen
                </text-heading>
                <text-description>
                    Er is een nieuw wachtwoord aangevraagd. Hier kan je deze opnieuw instellen.
                </text-description>

                <form-validation>
                    <input-group v-model="form.password" :schema="string().required()">
                        <template #label>
                            <input-label>
                                Wachtwoord
                            </input-label>
                        </template>
                        <template #input>
                            <text-input password />
                        </template>
                    </input-group>
                    <input-group v-model="form.passwordConfirmation" :schema="string().required()">
                        <template #label>
                            <input-label>
                                Herhaal je wachtwoord
                            </input-label>
                        </template>
                        <template #input>
                            <text-input password />
                        </template>
                    </input-group>

                    <button-block @click="savePassword">
                        Opslaan
                    </button-block>
                </form-validation>
            </flex-container>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import { useRouter } from 'vue-router';
    import { computed, ref } from 'vue';
    import LogoIcon from '@/assets/icons/logo.svg?component';
    import { Size } from '@keyvue/one-ui';
    import { string } from 'yup';
    import axios from 'axios';

    const baseUrl = import.meta.env.VITE_LEGACY_HOST;

    const router = useRouter();

    const form = ref({
        password: '',
        passwordConfirmation: '',
    });

    const request = computed(() => (router.currentRoute.value.params.requestId));

    async function savePassword() {
        if (form.value.password !== form.value.passwordConfirmation) {
            return;
        }

        await axios.post(`${baseUrl}/do_password_reset`, {
            request: request.value,
            password: form.value.password,
        });

        window.location.replace(`${import.meta.env.VITE_LEGACY_APP_HOST}/user/login`);
    }
</script>
